import React from 'react'

/* Inline SVGs of the create-event modal (mock _kit/create.html): 16px stroke icons on the
   segmented toggles, the range field and the calendar navigation. */

const stroke = (width) => ({
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: width,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
})

export const PinIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" className={className} {...stroke(2)}>
        <path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z" />
        <circle cx="12" cy="10" r="2.6" />
    </svg>
)

export const GlobeIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" className={className} {...stroke(2)}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M3.5 12h17M12 3.5c3 3 3 14 0 17M12 3.5c-3 3-3 14 0 17" />
    </svg>
)

export const FunctionalIcon = ({ className }) => (
    <svg viewBox="0 0 17 21" className={className} {...stroke(1.6)}>
        <circle cx="8.5" cy="3" r="2.2" fill="currentColor" stroke="none" />
        <path d="M8.5 6.6v6.2" />
        <path d="M2 8.4h13" />
        <path d="M8.5 12.8 4.6 19.6" />
        <path d="m8.5 12.8 3.9 6.8" />
    </svg>
)

export const HybridIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" className={className} {...stroke(2)}>
        <circle cx="15" cy="4.5" r="2" />
        <path d="m5 20 3-5 4-2-2-4 5-1M9 9 6 7" />
    </svg>
)

export const WorkshopIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" className={className} {...stroke(2)}>
        <path d="M3 8.5 12 4l9 4.5-9 4.5z" />
        <path d="M7 11v5c0 1.4 2.2 2.5 5 2.5s5-1.1 5-2.5v-5" />
    </svg>
)

export const CalendarIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" className={className} {...stroke(1.9)}>
        <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
        <path d="M8 3v4M16 3v4M3.5 10h17" />
    </svg>
)

export const ArrowRightIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" className={className} {...stroke(2.2)}>
        <path d="M4 12h16m-6-6 6 6-6 6" />
    </svg>
)

export const ChevronLeftIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" className={className} {...stroke(2.2)}>
        <path d="m15 6-6 6 6 6" />
    </svg>
)

export const ChevronRightIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" className={className} {...stroke(2.2)}>
        <path d="m9 6 6 6-6 6" />
    </svg>
)
